import {apiGet, apiPost} from "../../shared/api/client";
import {i18n} from "../../shared/i18n";


const cleanParams = (filters) =>
    Object.fromEntries(Object.entries(filters || {}).filter(([, value]) => value !== "" && value !== null && value !== undefined));

const idempotencyConfig = (idempotencyKey, params) => ({
    headers: {"Idempotency-Key": idempotencyKey},
    ...(params ? {params} : {}),
});

export const normalizePhoneNumber = (value) => {
    const text = String(value || "").trim();
    const digits = text.replace(/\D/g, "");
    return text.startsWith("+") && digits ? `+${digits}` : digits;
};

// Серверный дефолт page_size (sorpa-backend#19, clamp_admin_page_size: дефолт 20,
// кэп 100). Дефолт не шлём: поведение существующих клиентов не меняется, а до
// мержа бэкенда ninja молча игнорирует лишний параметр.
const DEFAULT_PAGE_SIZE = 20;

export const loadUsers = async ({countryId, page = 1, search, pageSize} = {}) =>
    apiGet("/api/v2/admin/users", {
        params: cleanParams({
            country_id: countryId,
            page,
            search,
            page_size: Number(pageSize) === DEFAULT_PAGE_SIZE ? undefined : pageSize,
        }),
    });

export const createUser = async ({name, phoneNumber, countryId} = {}) =>
    apiPost(
        "/api/v2/admin/users",
        {
            name: String(name || "").trim(),
            phone_number: normalizePhoneNumber(phoneNumber),
        },
        {params: cleanParams({country_id: countryId})},
    );

export const loadUserListingDetail = async (userId) =>
    apiGet(`/api/v2/admin/users/${userId}/listing`);

export const loadUserHistory = async (userId, filters = {}) =>
    apiGet(`/api/v2/admin/listing/${userId}`, {params: cleanParams(filters)});

export const loadUserData = async (userId, {countryId} = {}) =>
    apiGet(`/api/v2/admin/users/${userId}/data`, {
        params: cleanParams({country_id: countryId}),
    });

export const changeUserRefCode = async ({userId, refCode, countryId}) =>
    apiPost(
        `/api/v2/admin/users/${userId}/ref-code`,
        {ref_code: String(refCode || "").trim()},
        {params: cleanParams({country_id: countryId})},
    );

export const setUserStatus = async ({userId, isBlocked}) =>
    apiPost(`/api/v2/admin/users/${userId}/status`, {is_blocked: Boolean(isBlocked)});

export const setUserRefEnabled = async ({userId, isRefEnabled}) =>
    apiPost(`/api/v2/admin/users/${userId}/ref-enabled`, {is_ref_enabled: Boolean(isRefEnabled)});

export const setUserFraud = async ({userId, isFraud}) =>
    apiPost(`/api/v2/admin/users/${userId}/fraud`, {is_fraud: Boolean(isFraud)});

export const fillUserPlus = async ({userId, amount, idempotencyKey}) =>
    apiPost(
        `/api/v2/admin/users/${userId}/fill-plus`,
        {fill_sum: String(amount)},
        idempotencyConfig(idempotencyKey),
    );

export const fillUserPoints = async ({userId, amount, idempotencyKey}) =>
    apiPost(
        `/api/v2/admin/users/${userId}/fill-points`,
        {fill_sum: String(amount)},
        idempotencyConfig(idempotencyKey),
    );

export const fillUserBonus = async ({userId, amount, countryId, idempotencyKey}) =>
    apiPost(
        `/api/v2/admin/users/${userId}/fill-bonus`,
        {fill_sum: String(amount)},
        idempotencyConfig(idempotencyKey, cleanParams({country_id: countryId})),
    );

export const manualUserPlusTopup = async ({userId, amount, countryId, idempotencyKey}) =>
    apiPost(
        `/api/v2/admin/users/${userId}/manual-plus-topup`,
        {fill_sum: String(amount)},
        idempotencyConfig(idempotencyKey, cleanParams({country_id: countryId})),
    );

export const transferUserMoney = async ({userId, amount, direction, idempotencyKey}) =>
    apiPost(
        `/api/v2/admin/users/${userId}/transfer-money`,
        {fill_bin: direction, transfer_sum: String(amount)},
        idempotencyConfig(idempotencyKey),
    );

export const zeroUserAccount = async ({userId, idempotencyKey}) =>
    apiPost(
        `/api/v2/admin/users/${userId}/zero-account`,
        undefined,
        idempotencyConfig(idempotencyKey),
    );

const requiredUserId = (value) => {
    const normalized = String(value ?? "").trim();
    if (!/^[1-9]\d*$/.test(normalized)) throw new Error(i18n.t("sections.users.p146"));
    return normalized;
};

// Не async: валидация должна бросать синхронно, иначе вызывающий код получает
// отклонённый промис вместо ошибки. country_id допишет интерцептор, ninja его
// игнорирует — это нормально.
export const issueUserSupportCode = ({userId, reason}) => {
    const id = requiredUserId(userId);
    const trimmed = String(reason ?? "").trim();
    if (trimmed.length < 5) throw new Error(i18n.t("sections.users.p92"));
    return apiPost(`/api/v2/admin/users/${id}/support-code`, {reason: trimmed});
};
